import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Fastify.svg?component
var Fastify_exports = /* @__PURE__ */ __exportAll({
	default: () => Fastify_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "currentColor",
		d: "M23.241 7.492 24 5.536l-.031-.125-7.479 1.971c.798-1.158.524-2.08.524-2.08s-2.386 1.525-4.193 1.486c-1.807-.04-2.386-.525-5.155.36-2.769.883-3.551 3.59-4.357 4.177-.798.579-3.309 2.51-3.309 2.51l2.269-.727s-.642.61-1.964 2.386v.008c.211.297 1.142 1.525 2.065 1.26.102-.032.22-.087.352-.15.415.236.97.462 1.573.525 0 0-.407-.47-.751-1.017l.281-.18-.047.031.869.313-.094-.813h.008l.844.313-.101-.744.32-.156.884-3.348 3.661-2.503-.289.735c-.743 1.823-2.136 2.253-2.136 2.253l-.578.227c-.438.508-.618.634-.767 2.354.352-.093.68-.11.986-.03 1.564.422 2.104 2.307 1.681 2.831-.101.125-.352.352-.672.61H7.76l-.008.516-.062.055h-.65l-.007.5-.173.126c-.602.016-1.376-.516-1.376-.516.008.485.406 1.228.406 1.228l.07-.04-.062.048s1.627 1.08 2.652.68c.908-.36 3.262-2.214 5.296-3.09l6.149-1.627.813-2.096-4.685 1.236V13.14l5.499-1.448.814-2.104-6.313 1.666V9.37zm-11.163 3.997 1.463-.383.016.07-.454 1.181-1.51.4zm.5 2.527-1.509.399.493-1.268 1.455-.383.023.07zm1.972-.423-1.51.4.493-1.268 1.455-.383.024.07z"
	}, null, -1)])]);
}
var Fastify_default = { render: render$1 };
//#endregion
export { Fastify_exports, Fastify_default as default, render$1 as render };

//# sourceMappingURL=Fastify.svg.virtual.js.map